import React from 'react'

import { SiteContext } from 'context/site-context'

import {
  getGeoFromLocalStorage,
} from 'helpers'

import AutoSuggest from 'components/atoms/AutoSuggest'

import './index.scss'

const useFocus = () => {
  const htmlElRef = React.useRef(null)
  const setFocus = () => {htmlElRef.current &&  htmlElRef.current.focus()}

  return [ htmlElRef, setFocus ]
}

const SearchForm = props => {
  const [ site, setSite ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    term: new URLSearchParams(window.location.search).get('term') || site.term || localStorage.getItem('term') || '',
    location: new URLSearchParams(window.location.search).get('where') || site.location || getGeoFromLocalStorage()?.location || '',
  })

  const [ errors, setErrors ] = React.useState({})

  const [ locationRef ] = useFocus()
  const [ submitRef ] = useFocus()

  const handleEnterPress = (term = '') => {
    if(term === 'category'){
      // Set focus to the location input (as if the user presssed tab)
      locationRef.current.children[0].querySelector('input').focus()
    }
    if(term === 'location'){
      // Set focus to the submit button
      // Can this NOT auto-trigger a click?
      setTimeout( () => {
        submitRef.current.focus()
      }, 250)
    }
  }

  const handleSubmit = () => {
    setErrors({})

    // Simply check for a term and a location.
    if(state.term && state.location){
      localStorage.setItem('geoInfo', JSON.stringify({
        location: state.location,
      }))
      localStorage.setItem('term', state.term)
      setSite({
        ...site,
        location: state.location,
        term: state.term,
      })
      // Route the user off to the results page.
      window.location.href = `${window.location.origin}/results?term=${state.term}&where=${state.location}`
    } else {
      const errors = {}
      if(!state.term){
        errors.term = true
      }
      if(!state.location){
        errors.location = true
      }
      setErrors(errors)
    }
  }

  // const handleKeyDown = React.useCallback( e => {
  //   if(e.keyCode === 13) { // 'User pressed enter key')
  //     handleSubmit()
  //   }
  // }, [handleSubmit])

  // React.useEffect( () => {
  //   // if(props.category?.name){
  //   //   setState( prevState => ({
  //   //     ...prevState,
  //   //     term: props.category.name,
  //   //   }))
  //   // }
  // }, [props.category])

  // React.useEffect( () => {
  //   // if(props.location?.name){
  //   //   setState( prevState => ({
  //   //     ...prevState,
  //   //     location: props.location.name,
  //   //   }))
  //   // }
  // }, [props.location])

  // React.useEffect(() => {
  //   window.addEventListener('keydown', handleKeyDown)
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown)
  //   }
  // }, [handleKeyDown])

  // React.useEffect(() => {
  //   setState( prevState => ({
  //     ...prevState,
  //     location: site.location
  //   }))
  // }, [site.location])

  return <div className={`form-container ${props.className || ''}`}>
    <fieldset className="panel-content">
      <div className="row">
        <div className="input-container">
        <AutoSuggest
            fetchUrl="https://apis.elocal.com/type-ahead/category/autocomplete"
            searchParam="prompt"
            placeholder="Service Needed"
            maxResults={10}
            defaultOptionsLabel="Search Term"
            onSelect={ option => {
              setState({
                ...state,
                term: option.label,
              })
            }}
            onChange={ value => {
              setErrors({
                ...errors,
                term: null,
              })
              setState({
                ...state,
                term: value,
              })
            }}
            onEnter={ () => handleEnterPress('category') }
            defaultValue={state.term || null}
            renderLabel={ option => option.label}
            optionLabel="category_name"
            optionId="category_id"
            responseCollectionKey="categories"
          />
          {errors.term && <div className="error">Please enter a search term.</div>}
        </div>
        <div className="input-container" ref={locationRef}>
          <AutoSuggest
              fetchUrl="https://apis.elocal.com/type-ahead/geography/autocomplete"
              searchParam="prompt"
              placeholder="City, St or Zip"
              maxResults={10}
              defaultOptionsLabel="City, St or Zip"
              onSelect={ option => {
                setState({
                  ...state,
                  location: option.label,
                })
              }}
              onChange={ value => {
                setErrors({
                  ...errors,
                  location: null,
                })
                setState({
                  ...state,
                  location: value,
                })
              }}
              onEnter={ () => handleEnterPress('location') }
              defaultValue={state.location || null}
              renderLabel={ option => option.label }
              optionLabel="geography_display_name"
              optionId="geography_id"
              responseCollectionKey="geographies"
          />
          {errors.location && <div className="error">Please enter a location.</div>}
        </div>
        <button className="button-trigger" onClick={() => handleSubmit()} ref={submitRef}>Search</button>
      </div>
    </fieldset>
  </div>
}

export default SearchForm
